// frontend/src/components/WelcomeModal.jsx
// Affiché une seule fois au premier lancement — styles inline uniquement.
import { useState } from "react";
import { useNavigate } from "react-router-dom";

const STORAGE_KEY = "crushnow_welcome_seen";

const steps = [
  {
    id: 1,
    content: (
      <>
        <div style={{ fontSize: "32px", marginBottom: "12px" }}>💘</div>
        <h2 style={{ fontSize: "20px", fontWeight: 800, color: "#0f172a", margin: "0 0 8px" }}>
          Bienvenue sur CrushNow®
        </h2>
        <p style={{ fontSize: "13px", color: "#64748b", marginBottom: "20px" }}>
          On te dit tout avant de commencer.
        </p>
        <div style={{ background: "#f8fafc", borderRadius: "10px", padding: "16px", textAlign: "left" }}>
          <p style={{ fontWeight: 700, fontSize: "13px", color: "#0f172a", marginBottom: "10px" }}>
            📦 Ce qu'on enregistre quand tu scannes :
          </p>
          <ul style={{ listStyle: "none", padding: 0, margin: 0, fontSize: "13px", color: "#334155", lineHeight: 2 }}>
            <li>• Le code-barres du produit</li>
            <li>• L'heure et la date</li>
            <li>• Le magasin où tu étais (si tu actives la géoloc)</li>
          </ul>
        </div>
        <p style={{ fontSize: "13px", color: "#64748b", marginTop: "16px", lineHeight: 1.6 }}>
          📍 <strong>La géoloc est 100% optionnelle.</strong><br />
          Tu l'actives quand tu veux, tu la coupes quand tu veux.
        </p>
      </>
    ),
  },
  {
    id: 2,
    content: (
      <>
        <div style={{ fontSize: "32px", marginBottom: "12px" }}>🔒</div>
        <h2 style={{ fontSize: "20px", fontWeight: 800, color: "#0f172a", margin: "0 0 20px" }}>
          Ce qu'on ne fait JAMAIS
        </h2>
        <ul style={{ listStyle: "none", padding: 0, margin: "0 0 20px", textAlign: "left" }}>
          {[
            "On ne vend pas tes données",
            "On ne partage pas ton profil",
            "On n'affiche pas de publicité",
            "On ne transmet jamais ton nom ou ton email à un magasin",
          ].map((item) => (
            <li key={item} style={{ fontSize: "13px", color: "#334155", padding: "6px 0", borderBottom: "1px solid #f1f5f9", display: "flex", gap: "8px", alignItems: "flex-start" }}>
              <span style={{ color: "#dc2626", fontWeight: 700, flexShrink: 0 }}>✗</span>
              {item}
            </li>
          ))}
        </ul>
        <div style={{ background: "#f0fdf4", borderRadius: "10px", padding: "14px", textAlign: "left" }}>
          <p style={{ fontWeight: 700, fontSize: "13px", color: "#166534", marginBottom: "6px" }}>
            📊 Les gérants de magasins voient uniquement :
          </p>
          <p style={{ fontSize: "13px", color: "#15803d", fontStyle: "italic", margin: 0 }}>
            "47 personnes ont scanné ce produit ce mois-ci"
          </p>
          <p style={{ fontSize: "12px", color: "#64748b", marginTop: "6px", margin: "6px 0 0" }}>
            Ils ne savent pas que c'est toi.
          </p>
        </div>
      </>
    ),
  },
  {
    id: 3,
    content: (
      <>
        <div style={{ fontSize: "32px", marginBottom: "12px" }}>🗝️</div>
        <h2 style={{ fontSize: "20px", fontWeight: 800, color: "#0f172a", margin: "0 0 20px" }}>
          Tu choisis comment t'inscrire
        </h2>
        <div style={{ display: "flex", flexDirection: "column", gap: "12px", textAlign: "left" }}>
          <div style={{ background: "#fdf2f8", borderRadius: "10px", padding: "14px" }}>
            <p style={{ fontWeight: 700, fontSize: "13px", color: "#9d174d", margin: "0 0 4px" }}>📧 Avec email</p>
            <p style={{ fontSize: "12px", color: "#64748b", margin: 0 }}>Récupération de compte par email.</p>
          </div>
          <div style={{ background: "#f0f9ff", borderRadius: "10px", padding: "14px" }}>
            <p style={{ fontWeight: 700, fontSize: "13px", color: "#0369a1", margin: "0 0 4px" }}>👤 Sans email</p>
            <p style={{ fontSize: "12px", color: "#64748b", margin: 0 }}>
              Zéro donnée personnelle.<br />
              On te génère 12 mots secrets à noter —<br />
              c'est ta seule clé de récupération.
            </p>
          </div>
        </div>
      </>
    ),
  },
];

export default function WelcomeModal() {
  const seen = localStorage.getItem(STORAGE_KEY);
  const [visible, setVisible] = useState(!seen);
  const [step, setStep] = useState(0);
  const navigate = useNavigate();

  if (!visible) return null;

  const handleClose = () => {
    localStorage.setItem(STORAGE_KEY, "true");
    setVisible(false);
  };

  const isLast = step === steps.length - 1;

  return (
    <div
      onClick={handleClose}
      style={{
        position: "fixed", inset: 0,
        background: "rgba(0,0,0,0.85)",
        display: "flex", alignItems: "center", justifyContent: "center",
        zIndex: 9999, padding: "16px",
      }}
    >
      <div
        onClick={e => e.stopPropagation()}
        style={{
          position: "relative",
          background: "white", borderRadius: "16px",
          maxWidth: "380px", width: "100%",
          padding: "28px 24px 24px",
          textAlign: "center",
          maxHeight: "90vh", overflowY: "auto",
        }}
      >
        <button
          onClick={handleClose}
          style={{
            position: "absolute", top: "12px", right: "12px",
            background: "none", border: "none", fontSize: "18px",
            color: "#94a3b8", cursor: "pointer", lineHeight: 1,
            padding: "4px"
          }}
        >
          ✕
        </button>

        {/* Contenu de l'étape */}
        <div style={{ marginBottom: "24px" }}>
          {steps[step].content}
        </div>

        {/* Points de navigation */}
        <div style={{ display: "flex", justifyContent: "center", gap: "8px", marginBottom: "20px" }}>
          {steps.map((_, i) => (
            <div
              key={i}
              style={{
                width: "8px", height: "8px", borderRadius: "50%",
                background: i === step ? "#e11d48" : "#e2e8f0",
                transition: "background 0.2s",
              }}
            />
          ))}
        </div>

        {/* Boutons étapes 1 & 2 */}
        {!isLast && (
          <button
            onClick={() => setStep((s) => s + 1)}
            style={{
              width: "100%", padding: "13px",
              background: "#e11d48", color: "white",
              border: "none", borderRadius: "10px",
              fontSize: "15px", fontWeight: 700, cursor: "pointer",
            }}
          >
            Suivant →
          </button>
        )}

        {/* Boutons étape 3 */}
        {isLast && (
          <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
            <button
              onClick={() => { handleClose(); navigate("/register"); }}
              style={{
                width: "100%", padding: "13px",
                background: "#e11d48", color: "white",
                border: "none", borderRadius: "10px",
                fontSize: "14px", fontWeight: 700, cursor: "pointer",
              }}
            >
              S'inscrire avec email
            </button>
            <button
              onClick={() => { handleClose(); navigate("/register?mode=pseudo"); }}
              style={{
                width: "100%", padding: "13px",
                background: "#f1f5f9", color: "#1e293b",
                border: "none", borderRadius: "10px",
                fontSize: "14px", fontWeight: 600, cursor: "pointer",
              }}
            >
              S'inscrire sans email
            </button>
          </div>
        )}
      </div>
    </div>
  );
}
